import React, { Component } from 'react';
import './Loader.css';
import PuffLoader from "react-spinners/PuffLoader";

class Loader extends Component {


  render() {
    return (
        <div className="Loading-header">
          <PuffLoader
            size={'40vw'}
            color={"#fff"}
            loading={true}
          />
        </div>)
       
  }
}

export default Loader;